import React, { useEffect, useState } from "react"
import Moment from "react-moment"
import { getFieldData } from "../../../Services/appService"
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../../store/auth";
import {
    appFormLibraryRecevied,
    getAppDocuments,
    getAppFormLibrary, getAppTasks, getCandidateApps,
    loadAppDocuments,
    loadAppFormLibrary, loadAppRuningTasks, loadCandidateApps
} from "../../store/candidate";
import ViewForm from "../../../Components/ApplicantProcessing/ViewForm";
import AddEditNotes from "../../../Components/ApplicantProcessing/AddEditNotes";
import CandidateInfo from "../CandidateInfo";
import PageHeader from "../../../Components/Comman/PageHeader";
import OnboardingSteps from "./OnboardingSteps";
import PartnerInfo from "../PartnerInfo";
import EnrollmentSteps from "./EnrollmentSteps";
import TimerPopup from "../../../Components/TimerPopup";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import UploadDocPopup from "../../../Components/UploadDocPopup";
import ViewFormModal from "../ViewFormModal";
import useDocDownload from "../../hooks/useDocDownload";
import { allowFormLibraryEdit, getFormLibraryEditStatus } from "../../store/forms";
import { getComponentUserStatus, getToolsCount, UpdateComponentsUserStatus } from "../../store/tools";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getAlert, getConfirmAlert } from "../../../Services/appAlerts";
import { deleteDocument, getDocumentDeleteStatus } from "../../store/documents";

const INSURANCE_STYLES = {
    card: {
        borderRadius: "22px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
        boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    cardHeader: {
        padding: "20px 22px 16px 22px",
        borderBottom: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    headerCopy: {
        minWidth: "240px",
        flex: "1 1 420px"
    },
    headerActions: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "10px",
        flexWrap: "wrap"
    },
    title: {
        fontSize: "18px",
        fontWeight: 800,
        color: "#0f172a",
        lineHeight: 1.25,
        margin: 0
    },
    titleRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px"
    },
    titleIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eff6ff",
        color: "#1d4ed8",
        fontSize: "15px",
        border: "1px solid rgba(191, 219, 254, 1)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        minWidth: 0
    },
    subtitle: {
        fontSize: "13px",
        lineHeight: 1.5,
        color: "#64748b",
        margin: 0
    },
    heroButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 1)",
        background: "#eff6ff",
        color: "#1d4ed8",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    cardBody: {
        padding: "18px 22px 22px 22px"
    },
    utilityRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        marginBottom: "14px"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    tableWrap: {
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "18px",
        overflow: "auto",
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)"
    },
    table: {
        marginBottom: 0,
        minWidth: "1080px",
        borderCollapse: "separate",
        borderSpacing: 0
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "12px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        padding: "14px 16px"
    },
    cell: {
        verticalAlign: "top",
        padding: "22px 16px",
        borderTop: "1px solid rgba(226, 232, 240, 0.75)"
    },
    summaryGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
        gap: "12px",
        marginBottom: "14px"
    },
    summaryItem: {
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "14px",
        padding: "12px 14px",
        background: "#ffffff"
    },
    summaryLabel: {
        fontSize: "11px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        marginBottom: "6px"
    },
    summaryValue: {
        fontSize: "20px",
        fontWeight: 800,
        color: "#0f172a",
        lineHeight: 1
    },
    insurerName: {
        fontSize: "14px",
        fontWeight: 700,
        color: "#0f172a",
        lineHeight: 1.5
    },
    rowTitle: {
        fontSize: "12px",
        fontWeight: 700,
        color: "#0f172a",
        lineHeight: 1.55
    },
    rowText: {
        fontSize: "12px",
        color: "#475569",
        lineHeight: 1.55
    },
    primaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 1)",
        background: "#eff6ff",
        color: "#1d4ed8",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    secondaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    formActionButton: {
        minWidth: "188px",
        justifyContent: "flex-start",
        padding: "10px 12px",
        borderRadius: "14px",
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.05)"
    },
    formActionIcon: {
        width: "28px",
        height: "28px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.72)",
        border: "1px solid rgba(226, 232, 240, 0.9)",
        flexShrink: 0
    },
    formActionCopy: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "2px",
        lineHeight: 1.1
    },
    formActionText: {
        fontSize: "12px",
        fontWeight: 800,
        color: "inherit"
    },
    formActionHint: {
        fontSize: "11px",
        fontWeight: 600,
        color: "#64748b"
    },
    requestEditButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "7px",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 1)",
        backgroundColor: "#ffffff",
        color: "#1d4ed8",
        padding: "7px 11px",
        fontSize: "12px",
        fontWeight: 800,
        boxShadow: "0 6px 14px rgba(37, 99, 235, 0.06)"
    },
    textButton: {
        border: "none",
        background: "transparent",
        color: "#2563eb",
        padding: 0,
        fontSize: "12px",
        fontWeight: 700
    },
    dangerButton: {
        border: "none",
        background: "transparent",
        color: "#dc2626",
        padding: 0,
        fontSize: "12px",
        fontWeight: 700
    },
    mutedText: {
        fontSize: "12px",
        color: "#64748b",
        lineHeight: 1.55
    },
    statusPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
        border: "1px solid rgba(226, 232, 240, 1)",
        backgroundColor: "#f8fafc",
        color: "#475569"
    },
    completePill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "7px",
        padding: "6px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
        border: "1px solid rgba(187, 247, 208, 1)",
        backgroundColor: "#f0fdf4",
        color: "#166534"
    },
    pendingPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "7px",
        padding: "6px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
        border: "1px solid rgba(253, 230, 138, 1)",
        backgroundColor: "#fffbeb",
        color: "#92400e"
    },
    missingPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "7px",
        padding: "6px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
        border: "1px solid rgba(254, 202, 202, 1)",
        backgroundColor: "#fef2f2",
        color: "#b91c1c"
    },
    docListItem: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "10px",
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "12px",
        padding: "9px 10px",
        backgroundColor: "#f8fafc",
        maxWidth: "280px"
    },
    docName: {
        maxWidth: "190px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    emptyState: {
        padding: "28px 20px",
        textAlign: "center",
        color: "#64748b",
        fontSize: "13px"
    }
};

export default function AchInfo() {

    const route = [
        { name: "Contract Management", url: "" },
        { name: "Enrollment Steps", url: "" },
    ];

    const [appFormLibrary, setAppFormLibrary] = useState([]);
    const [sentDocs, setSentDocs] = useState([]);
    const [wfTask, setWfTask] = useState(null);
    const [workflow, setWorkflow] = useState(null);
    const [formType, setFormType] = useState("Insurance Information");
    const [formShowHide, setFormShowHide] = useState(false);
    const [formObj, setFormObj] = useState(null);
    const [noteShowHide, setNoteShowHide] = useState(false);
    const [timerShowHide, setTimerShowHide] = useState(false);
    const [notesType, setNotesType] = useState("formEditReq");
    const [appTasklist, setAppTasklist] = useState([]);
    const [selectedDocType, setSelectedDocType] = useState("");
    const [docUploadShowHide, setDocUploadShowHide] = useState(false);
    const [reviewerTask, setReviewerTask] = useState(null);
    const [allowEdit, setAllowEdit] = useState(false);

    const candidateAppsSelector = useSelector(getCandidateApps);
    const appTasksSelector = useSelector(getAppTasks);
    const appFormLibrarySelector = useSelector(getAppFormLibrary);
    const appDocumentsSelector = useSelector(getAppDocuments);
    const formLibraryEditStatusSelector = useSelector(getFormLibraryEditStatus);
    const componentUserStatusSelector = useSelector(getComponentUserStatus);
    const documentDeleteStatusSelector = useSelector(getDocumentDeleteStatus);

    const toolsCountSelector = useSelector(getToolsCount);
    const safeToolsCount = Array.isArray(toolsCountSelector) ? toolsCountSelector : [];
    const safeComponentUserStatus = Array.isArray(componentUserStatusSelector) ? componentUserStatusSelector : [];

    const [handleDownloadFile] = useDocDownload();

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        dispatch(setCurrentPageTitle("STEP-4 : Insurance Information"));
        dispatch(setCurrentRoute(route))
    }, [])

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;
        if (candidateAppsSelector.length === 0 && currentUser?.id > 0)
            dispatch(loadCandidateApps(usrId))
    }, []);

    useEffect(() => {
        if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                const wf = mainWorkflow[0];
                setWorkflow(wf);
                let usrId = currentUser.id;
                if (currentUser.linkUser)
                    usrId = currentUser.linkUser;
                if (currentUser?.id > 0) {
                    dispatch(loadAppFormLibrary(wf.oldWorkflowId, usrId));
                    dispatch(loadAppRuningTasks(wf.oldWorkflowId, usrId));
                    dispatch(loadAppDocuments(wf.oldWorkflowId, usrId));
                }

            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
            if (filterTasks.length > 0) {
                const reviewTasks = filterTasks.filter(x => x.registrationType === "WP");
                if (reviewTasks.length > 0) setReviewerTask(reviewTasks[reviewTasks.length - 1]);
                setAppTasklist(filterTasks);
                setWfTask(filterTasks[0]);
            }
        }
    }, [appTasksSelector]);

    useEffect(() => {
        if (appFormLibrarySelector.length > 0) {
            const frmLibrary = appFormLibrarySelector.filter(x => x.formType === formType);
            setAppFormLibrary(frmLibrary);

            if (frmLibrary.length > 0) {
                let frmItems = "";
                frmLibrary.map((x, key) => {
                    if (key > 0) frmItems += ",";
                    frmItems += x.id;
                });

                handleUpdateComponent(frmItems, frmLibrary[0].ciid);
            }
        }
    }, [appFormLibrarySelector]);

    useEffect(() => {
        if (appDocumentsSelector.length > 0) {
            const appDocs = appDocumentsSelector;
            let sentDocs = appDocs.filter(
                (x) =>
                    x.type === "send" &&
                    x.uploadType !== "Invoice" &&
                    x.docType !== "internal" &&
                    x.docType !== "Messaging"
            );
            setSentDocs(sentDocs);
        }
    }, [appDocumentsSelector])

    const getCIOStatus = (item) => {
        const insuranceDocs = sentDocs.filter(
            (x) => x.docType === `insurance_${item.id}`
        );

        if (insuranceDocs.length === 0) {
            return <button
                className="btn btn-sm border-0"
                style={INSURANCE_STYLES.primaryAction}
                onClick={() =>
                    handleUploadDocModalShowHide(`insurance_${item.id}`)
                }
            >
                <i className="fa fa-upload" aria-hidden="true"></i>
                Upload
            </button>
        }

        if (insuranceDocs.length > 0) {
            return <>
                <button
                    className="btn btn-sm border-0 mb-2"
                    style={INSURANCE_STYLES.primaryAction}
                    onClick={() =>
                        handleUploadDocModalShowHide(`insurance_${item.id}`)
                    }
                >
                    <i className="fa fa-upload" aria-hidden="true"></i>
                    Upload
                </button>
                {insuranceDocs.map(doc =>
                    <div key={doc.id} className="mb-2" style={INSURANCE_STYLES.docListItem}>
                        <div>
                            <button
                                className="btn btn-sm p-0"
                                style={{ ...INSURANCE_STYLES.textButton, ...INSURANCE_STYLES.docName }}
                                title={doc.documentName}
                                onClick={() => handleDownloadFile(doc)
                                }
                            >
                                <i className="fa fa-file-text-o mr-1" aria-hidden="true"></i>
                                {doc.documentName || "Document"}
                            </button>
                            <div>{getPopover(doc.notes)}</div>
                        </div>
                        <button
                            className="btn btn-sm p-0"
                            style={INSURANCE_STYLES.dangerButton}
                            title="Delete File"
                            onClick={() => handleDeleteInsuranceDoc(doc.id)}
                        >
                            <i
                                className="fa fa-trash"
                                aria-hidden="true"
                            ></i>
                        </button>
                    </div>
                )}
            </>
        }
    }

    const handleDeleteInsuranceDoc = async (id) => {
        const result = await getConfirmAlert("Warning", "Are you sure you want to delete this Document?", "warning");
        if (result.isConfirmed) {
            dispatch(deleteDocument(id));
        }
    }

    useEffect(() => {
        if (documentDeleteStatusSelector) {
            getAlert("", "Deleted Successfully", "success");
            let usrId = currentUser.id;
            if (currentUser.linkUser)
                usrId = currentUser.linkUser;
            if (workflow?.oldWorkflowId > 0) {
                dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
                dispatch(loadAppDocuments(workflow.oldWorkflowId, usrId));
            }
        }
    }, [documentDeleteStatusSelector])

    const handleUploadDocModalShowHide = (type) => {
        if (!reviewerTask) {
            getAlert("Warning", "No Reviewer Found. Please Complete Your Onboarding/Enrollment Form.", "warning");
            return;
        }

        const compName = getFieldData(wfTask?.stateData, "insurancedetails", "Name_of_the_Insurance_Company");
        const cglExp = getFieldData(wfTask?.stateData, "insurancedetails", "Commercial_General_Liability_Expiration");
        const autoExp = getFieldData(wfTask?.stateData, "insurancedetails", "Automobile_Liability_Expiration");
        const umbrellaExp = getFieldData(wfTask?.stateData, "insurancedetails", "Umbrella_Liab_Expiration");
        const workersExp = getFieldData(wfTask?.stateData, "insurancedetails", "Workers_Compensation_Expiration");
        const cyberExp = getFieldData(wfTask?.stateData, "insurancedetails", "Cyber_Privacy_Security_Liab_Expiration");
        const eoExp = getFieldData(wfTask?.stateData, "insurancedetails", "E_and_O_Liab_Expiration");

        if (!compName || !cglExp || !autoExp || !umbrellaExp || !workersExp || !cyberExp || !eoExp) {
            getAlert("Warning", "Please complete the Insurance Information form before uploading the COI document.", "warning");
            return;
        }

        if (type === "save" || type === "") {
            setDocUploadShowHide(false);
            setSelectedDocType("");
            let usrId = currentUser.id;
            if (currentUser.linkUser)
                usrId = currentUser.linkUser;
            if (workflow?.oldWorkflowId)
                dispatch(loadAppDocuments(workflow.oldWorkflowId, usrId));
        } else {
            setDocUploadShowHide(true);
            setSelectedDocType(type);
        }
    };

    const handleFormShowHide = (frm) => {
        if (frm === "save") {
            setFormShowHide(false);
            setFormObj("");
            let usrId = currentUser.id;
            if (currentUser.linkUser)
                usrId = currentUser.linkUser;
            if (workflow && currentUser?.id > 0) dispatch(loadAppRuningTasks(workflow.oldWorkflowId, usrId));
        } else {
            setFormShowHide(!formShowHide);
            setFormObj(frm);
            if (frm?.allowEdit === 1) setAllowEdit(true);
        }
    };

    const handleNotesComments = (type, obj) => {
        if (type === "save") {
            setFormObj(null);
            setNoteShowHide(false);
            let usrId = currentUser.id;
            if (currentUser.linkUser)
                usrId = currentUser.linkUser;
            if (workflow?.oldWorkflowId > 0)
                dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
        } else {
            setFormObj(obj);
            setNoteShowHide(!noteShowHide);
        }
    };

    const handleTimerModalShowHide = () => {
        setTimerShowHide(!timerShowHide);
    };

    const handleFormUpdate = () => {
        setAllowEdit(false);
        if (formObj?.id > 0)
            dispatch(allowFormLibraryEdit(formObj.id, 0));
    }

    useEffect(() => {
        if (formLibraryEditStatusSelector) {
            let usrId = currentUser.id;
            if (currentUser.linkUser)
                usrId = currentUser.linkUser;
            if (workflow?.oldWorkflowId > 0)
                dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
        }
    }, [formLibraryEditStatusSelector])

    const handleUpdateComponent = (compItems, ciid) => {
        const comp = safeComponentUserStatus.filter(x => x.compId === 21);
        let updCompItems = "";
        if (comp.length > 0) {
            updCompItems = comp[0].compItems;
        }
        const compObj = {
            compName: "Insurance",
            performerId: currentUser.id,
            compItems: compItems,
            ciid: ciid,
            wiid: 0,
            iiid: 0,
            compId: 21
        }
        if (compItems !== "" && compItems !== updCompItems) {
            dispatch(UpdateComponentsUserStatus(compObj));
        }
    }

    const getPopover = (notes) => {
        const popover = (
            <Popover id="popover-basic">
                <Popover.Title as="h4">Notes</Popover.Title>
                <Popover.Content>{notes}</Popover.Content>
            </Popover>
        );
        return (
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                <button className="btn btn-sm p-0" style={INSURANCE_STYLES.textButton}>View Notes</button>
            </OverlayTrigger>
        );
    };

    const getCount = (id) => {
        const toolObj = safeToolsCount.filter(x => x.key == id);
        if (toolObj.length > 0) return toolObj[0].value;
        return 0;
    }

    const getToolCount = (id) => {
        const compObj = safeComponentUserStatus.filter(x => x.compId === id);
        if (compObj.length > 0) {
            const unreadComps = compObj[0].unreadCompItems.split(',').sort();
            const readComps = compObj[0].compItems.split(',').sort();
            let unReadCount = 0;
            unreadComps.filter(x => x !== "").map(x => {
                const rs = readComps.filter(y => y === x);
                if (rs.length === 0) {
                    unReadCount += 1;
                }
            });
            if (unReadCount === 0) {
                return <span className="badge badge-pill badge-success ml-0 text-dark">
                    {getCount(id)}
                </span>
            }
            else {
                return <span className="badge badge-pill badge-danger ml-0">
                    {unReadCount}
                </span>
            }

        } else {
            return <span className="badge badge-pill badge-danger ml-0">
                {getCount(id)}
            </span>
        }
    }

    const handleDocumentLoad = () => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;
        if (workflow?.oldWorkflowId > 0) {
            dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
            dispatch(loadAppDocuments(workflow.oldWorkflowId, usrId));
        }
    }

    const showInsuranceDetails = appFormLibrary.some((item) => item?.lastUpdate);
    const insuranceDocumentCount = sentDocs.filter((doc) => doc.docType?.startsWith("insurance_")).length;
    const completedFormCount = appFormLibrary.filter((item) => item?.lastUpdate).length;

    return <React.Fragment>

        <div className="form-group mt-2">
            <style>{`
                .insurance-info-table tbody tr:hover {
                    background-color: #fbfdff;
                }
            `}</style>
            <div className="card shadow-none border-1" style={INSURANCE_STYLES.card}>
                <div className="card-header border-1" style={INSURANCE_STYLES.cardHeader}>
                    <div style={INSURANCE_STYLES.headerRow}>
                        <div style={INSURANCE_STYLES.headerCopy}>
                            <div style={INSURANCE_STYLES.titleRow}>
                                <span style={INSURANCE_STYLES.titleIcon}>
                                    <i className="fa fa-shield" aria-hidden="true"></i>
                                </span>
                                <div style={INSURANCE_STYLES.titleText}>
                                    <div style={INSURANCE_STYLES.title}>
                                        Insurance Information
                                    </div>
                                    <p style={INSURANCE_STYLES.subtitle}>
                                        Complete the insurance form, review policy details, and upload COI documents from one place.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={INSURANCE_STYLES.headerActions}>
                            <button
                                className="btn btn-sm"
                                style={INSURANCE_STYLES.refreshButton}
                                onClick={handleDocumentLoad}
                            >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                Refresh
                            </button>
                            <button
                                className="btn btn-sm"
                                style={INSURANCE_STYLES.heroButton}
                                onClick={handleTimerModalShowHide}
                            >
                                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                Expiration Alert {getToolCount(27)}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body border-1" style={INSURANCE_STYLES.cardBody}>
                    <div style={INSURANCE_STYLES.summaryGrid}>
                        <div style={INSURANCE_STYLES.summaryItem}>
                            <div style={INSURANCE_STYLES.summaryLabel}>Insurance Forms</div>
                            <div style={INSURANCE_STYLES.summaryValue}>{appFormLibrary.length}</div>
                        </div>
                        <div style={INSURANCE_STYLES.summaryItem}>
                            <div style={INSURANCE_STYLES.summaryLabel}>Completed</div>
                            <div style={INSURANCE_STYLES.summaryValue}>{completedFormCount}</div>
                        </div>
                        <div style={INSURANCE_STYLES.summaryItem}>
                            <div style={INSURANCE_STYLES.summaryLabel}>COI Documents</div>
                            <div style={INSURANCE_STYLES.summaryValue}>{insuranceDocumentCount}</div>
                        </div>
                    </div>
                    <div className="table-responsive" style={INSURANCE_STYLES.tableWrap}>
                        <table className="table align-items-center table-hover mb-0 insurance-info-table" style={INSURANCE_STYLES.table}>
                            <thead>
                                <tr>
                                    {showInsuranceDetails && <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>Insurer</th>}
                                    {showInsuranceDetails && <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>Type of Insurance</th>}
                                    {showInsuranceDetails && <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>Policy Number</th>}
                                    {showInsuranceDetails && <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>Expiry Date</th>}
                                    <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>Status</th>
                                    <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>Action</th>
                                    <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>COI</th>
                                </tr>
                            </thead>

                            <tbody>
                                {appFormLibrary.map((item, index) => {
                                    const insurance =
                                        wfTask && wfTask.stateData
                                            ? {
                                                company: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Name_of_the_Insurance_Company"
                                                ),
                                                cglPolicy: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Commercial_General_Liability_Policy_Number"
                                                ),
                                                cglExp: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Commercial_General_Liability_Expiration"
                                                ),
                                                autoPolicy: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Automobile_Liability_Policy_Number"
                                                ),
                                                autoExp: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Automobile_Liability_Expiration"
                                                ),
                                                umbrellaPolicy: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Umbrella_Liab_Policy_Number"
                                                ),
                                                umbrellaExp: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Umbrella_Liab_Expiration"
                                                ),
                                                workersPolicy: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Workers_Compensation_Policy_Number"
                                                ),
                                                workersExp: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Workers_Compensation_Expiration"
                                                ),
                                                cyberPolicy: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Cyber_Privacy_Security_Liab_Policy_Number"
                                                ),
                                                cyberExp: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "Cyber_Privacy_Security_Liab_Expiration"
                                                ),
                                                eoPolicy: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "E_and_O_Liab_Policy_Number"
                                                ),
                                                eoExp: getFieldData(
                                                    wfTask.stateData,
                                                    "insurancedetails",
                                                    "E_and_O_Liab_Expiration"
                                                ),
                                            }
                                            : {};

                                    const { allowEdit, lastUpdate, editRemarks } = item;
                                    const insuranceRows = [
                                        { label: "Commercial General Liability", policy: insurance.cglPolicy, expiry: insurance.cglExp },
                                        { label: "Automobile Liability", policy: insurance.autoPolicy, expiry: insurance.autoExp },
                                        { label: "Umbrella Liability", policy: insurance.umbrellaPolicy, expiry: insurance.umbrellaExp },
                                        { label: "Workers Compensation & Employer's Liability", policy: insurance.workersPolicy, expiry: insurance.workersExp },
                                        { label: "Cyber & Privacy Security Liability", policy: insurance.cyberPolicy, expiry: insurance.cyberExp },
                                        { label: "E&O Liability", policy: insurance.eoPolicy, expiry: insurance.eoExp },
                                    ];
                                    const missingPolicyCount = insuranceRows.filter((row) => !row.policy || !row.expiry).length;

                                    return (
                                        <tr key={item.id || index}>
                                            {showInsuranceDetails && <>
                                                <td className="text-wrap align-top" style={INSURANCE_STYLES.cell}>
                                                    <div style={INSURANCE_STYLES.insurerName}>{insurance.company || "-"}</div>
                                                </td>

                                                <td className="align-top" style={INSURANCE_STYLES.cell}>
                                                    {insuranceRows.map((row, rowIndex) => (
                                                        <div key={`label_${rowIndex}`} className={rowIndex > 0 ? "mt-2" : ""} style={INSURANCE_STYLES.rowTitle}>
                                                            {row.label}
                                                        </div>
                                                    ))}
                                                </td>

                                                <td className="align-top" style={INSURANCE_STYLES.cell}>
                                                    {insuranceRows.map((row, rowIndex) => (
                                                        <div key={`policy_${rowIndex}`} className={rowIndex > 0 ? "mt-2" : ""} style={INSURANCE_STYLES.rowText}>
                                                            {row.policy || "-"}
                                                        </div>
                                                    ))}
                                                </td>

                                                <td className="align-top" style={INSURANCE_STYLES.cell}>
                                                    {insuranceRows.map((row, rowIndex) => (
                                                        <div key={`expiry_${rowIndex}`} className={rowIndex > 0 ? "mt-2" : ""} style={INSURANCE_STYLES.rowText}>
                                                            {row.expiry ? (
                                                                <Moment format="MMM Do YYYY">
                                                                    {row.expiry}
                                                                </Moment>
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </div>
                                                    ))}
                                                </td>
                                            </>}
                                            <td className="align-top" style={INSURANCE_STYLES.cell}>
                                                {!lastUpdate ? (
                                                    <span style={INSURANCE_STYLES.pendingPill}>
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                        Required
                                                    </span>
                                                ) : missingPolicyCount > 0 ? (
                                                    <span style={INSURANCE_STYLES.missingPill}>
                                                        <i className="fa fa-warning" aria-hidden="true"></i>
                                                        {missingPolicyCount} Missing
                                                    </span>
                                                ) : (
                                                    <span style={INSURANCE_STYLES.completePill}>
                                                        <i className="fa fa-check-circle" aria-hidden="true"></i>
                                                        Complete
                                                    </span>
                                                )}
                                            </td>
                                            <td className="align-top" style={INSURANCE_STYLES.cell}>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm border-0"
                                                    style={{
                                                        ...(allowEdit === 1 ? INSURANCE_STYLES.primaryAction : INSURANCE_STYLES.secondaryAction),
                                                        ...INSURANCE_STYLES.formActionButton
                                                    }}
                                                    onClick={() => handleFormShowHide(item)}
                                                >
                                                    <span style={INSURANCE_STYLES.formActionIcon}>
                                                        <i className={`fa ${!lastUpdate ? "fa-exclamation-circle" : allowEdit === 1 ? "fa-pencil-square-o" : "fa-eye"}`} aria-hidden="true"></i>
                                                    </span>
                                                    <span style={INSURANCE_STYLES.formActionCopy}>
                                                        <span style={INSURANCE_STYLES.formActionText}>
                                                            {!lastUpdate ? <>Complete Insurance <span className="text-danger">*</span></> : allowEdit === 1 ? "Edit Insurance" : "View Insurance"}
                                                        </span>
                                                        <span style={INSURANCE_STYLES.formActionHint}>
                                                            {!lastUpdate ? "Required form" : allowEdit === 1 ? "Changes enabled" : "Read-only form"}
                                                        </span>
                                                    </span>
                                                </button>

                                                {lastUpdate && (
                                                    <div className="mt-2" style={INSURANCE_STYLES.mutedText}>
                                                        <strong>Last Edited:</strong>{" "}
                                                        <Moment format="MMM Do YYYY, h:mm a">
                                                            {lastUpdate}
                                                        </Moment>
                                                    </div>
                                                )}

                                                {allowEdit === 0 && (
                                                    <div className="mt-1">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm border-0"
                                                            style={INSURANCE_STYLES.requestEditButton}
                                                            onClick={() => handleNotesComments("", item)}
                                                        >
                                                            <i className="fa fa-commenting-o" aria-hidden="true"></i>
                                                            Request Edit
                                                        </button>
                                                    </div>
                                                )}

                                                {allowEdit === 2 && (
                                                    <div className="mt-1" style={INSURANCE_STYLES.mutedText}>
                                                        <span style={INSURANCE_STYLES.statusPill}>Request Sent</span>
                                                        {editRemarks && (
                                                            <div className="mt-1">{editRemarks}</div>
                                                        )}
                                                    </div>
                                                )}
                                            </td>

                                            <td className="align-top" style={INSURANCE_STYLES.cell}>{getCIOStatus(item)}</td>
                                        </tr>
                                    );
                                })}
                                {appFormLibrary.length === 0 && (
                                    <tr>
                                        <td colSpan={showInsuranceDetails ? "7" : "3"} style={INSURANCE_STYLES.emptyState}>
                                            Insurance information is not available yet.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
        {docUploadShowHide &&
            <UploadDocPopup
                contactDoc="Insurance Document Uploaded Successfully"
                uploadDocShowHide={docUploadShowHide}
                handleUploadDocModalShowHide={handleUploadDocModalShowHide}
                runningApplication={reviewerTask ? [reviewerTask] : []}
                selectedDocType={selectedDocType}
            ></UploadDocPopup>}

        {formShowHide && <ViewFormModal
            viewFormShowHide={formShowHide}
            handleViewForm={handleFormShowHide}
            workflowTask={wfTask}
            selectedForm={formObj}
            handleFormUpdate={handleFormUpdate}
            allowEdit={allowEdit}
            formName="Insurance Information"
        ></ViewFormModal>}

        {/* {formShowHide && <ViewForm
            formShowHide={formShowHide}
            handleFormShowHide={handleFormShowHide}
            workflowTask={wfTask}
            selectedForm={formObj}
        ></ViewForm>} */}

        {noteShowHide && <AddEditNotes
            noteShowHide={noteShowHide}
            handleNoteShowHide={handleNotesComments}
            notesType={notesType}
            candidateObj={currentUser}
            selectedObj={formObj}
        ></AddEditNotes>}
        {timerShowHide &&
            <TimerPopup
                timerShowHide={timerShowHide}
                handleTimerModalShowHide={handleTimerModalShowHide}
                workflowTask={wfTask}
            ></TimerPopup>}
    </React.Fragment>
}



